module.exports = __webpack_public_path__ + "static/media/resourcesDayTracking.1d9fd25e.png";